var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-list',{attrs:{"size":"small","loading":_vm.loading,"data-source":_vm.resultList},scopedSlots:_vm._u([{key:"renderItem",fn:function(item){return _c('a-list-item',{},[_vm._v(" "+_vm._s(item)+" ")])}}])})}
var staticRenderFns = []

export { render, staticRenderFns }